/**
 * 按当前访问域名解析备案信息
 */

export function createEmptyDomainFiling(partial = {}) {
  return {
    enabled: true,
    host: '',
    label: '',
    icpNumber: '',
    icpUrl: 'https://beian.miit.gov.cn/',
    policeNumber: '',
    policeUrl: '',
    note: '',
    ...partial
  }
}

/** 去掉协议、路径、端口，保留 www 供规则配置；匹配时再去 www */
export function cleanHostToken(raw) {
  let h = String(raw || '').trim().toLowerCase()
  if (!h) return ''
  h = h.replace(/^https?:\/\//i, '')
  h = h.replace(/\/.*$/, '')
  h = h.replace(/:\d+$/, '')
  h = h.replace(/\.$/, '')
  return h
}

export function parseFilingHosts(hostField) {
  const raw = String(hostField || '')
    .replace(/[，；;]/g, ',')
    .replace(/\r?\n/g, ',')
  return raw
    .split(',')
    .map(cleanHostToken)
    .filter(Boolean)
}

export function stripWww(host) {
  return String(host || '').toLowerCase().replace(/^www\./, '')
}

export function getCurrentHostname() {
  if (typeof window === 'undefined' || !window.location) return ''
  return cleanHostToken(window.location.hostname)
}

/**
 * @param {object} site - siteSettings.config
 * @param {string} [hostname]
 * @returns {{
 *   matched: boolean,
 *   source: 'domain'|'none',
 *   host: string,
 *   label: string,
 *   icpNumber: string,
 *   icpUrl: string,
 *   policeNumber: string,
 *   policeUrl: string,
 *   rule: object|null
 * }}
 */
export function resolveDomainFiling(site, hostname) {
  const host = cleanHostToken(hostname || getCurrentHostname())
  const hostBare = stripWww(host)
  const fallbackUrl = String((site && site.icpUrl) || '').trim() || 'https://beian.miit.gov.cn/'
  const list = Array.isArray(site && site.domainFilings) ? site.domainFilings : []

  let matched = null
  if (hostBare && hostBare !== 'localhost' && !/^\d+\.\d+\.\d+\.\d+$/.test(hostBare)) {
    for (const rule of list) {
      if (!rule || rule.enabled === false) continue
      const aliases = parseFilingHosts(rule.host)
      if (!aliases.length) continue
      const hit = aliases.some((alias) => {
        const a = stripWww(alias)
        return a === hostBare || alias === host
      })
      if (hit) {
        matched = rule
        break
      }
    }
  }

  if (matched) {
    return {
      matched: true,
      source: 'domain',
      host,
      label: String(matched.label || '').trim(),
      icpNumber: String(matched.icpNumber || '').trim(),
      icpUrl: String(matched.icpUrl || '').trim() || fallbackUrl,
      policeNumber: String(matched.policeNumber || '').trim(),
      policeUrl: String(matched.policeUrl || '').trim(),
      rule: matched
    }
  }

  // 未命中域名规则：不回退默认备案，页脚不展示备案号
  return {
    matched: false,
    source: 'none',
    host,
    label: '',
    icpNumber: '',
    icpUrl: fallbackUrl,
    policeNumber: '',
    policeUrl: '',
    rule: null
  }
}
